import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { persistRefFromSearch } from "./referral";

/**
 * Keeps `?ref=CODE` from any public URL (`/`, `/from/:source`, `/quiz`, …) in sessionStorage
 * so the waitlist POST can send it after the visitor navigates around the site.
 */
export function ReferralCapture() {
  const { search } = useLocation();
  useEffect(() => {
    persistRefFromSearch(search);
  }, [search]);
  return null;
}
